import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import { ColorRing } from 'react-loader-spinner'
import { EXPANSION_KITS } from '../../utils/expansionKits'

import '../Make/Make.css'

import MakeHeader from '../ReusableComponents/Header/MakeHeader'
import getBackendImage from '../../source/imageUtil'
import contentApi, { USE_NEW_API } from '../../utils/contentApi'

const BACKEND_URL = process.env.REACT_APP_API_BASE

const Play = (props) => {
    const history = useHistory()
    const device = sessionStorage.getItem('allowedDevice') || 'Toki'
    const deviceVersion = sessionStorage.getItem('deviceVersion')?.split('.')?.slice(0, 2)?.join('.') || '1.0'
    const expansionKit = sessionStorage.getItem('expansionKit')

    const [program, setProgram] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        ;(USE_NEW_API
            ? contentApi.getProgramSubprograms(device.toLowerCase())
            : fetch(`${BACKEND_URL}/api/program/${device.toLowerCase()}`).then(
                  (res) => res.json()
              )
        )
            .then((data) => {
                setProgram(data)
                setLoading(false)
            })
            .catch((err) => {
                console.error('Failed to load program:', err)
                setLoading(false)
            })
    }, [])

    const goBack = () => {
        history.push('/kitMenu')
    }

    const openSubprogram = (subId) => {
        if (props.isConnecting) return
        sessionStorage.setItem('playSubprogramId', subId)
        history.push('/PlayScreen')
    }

    // Only show subprograms that have at least one screen of type 'play',
    // and (when entered via an expansion kit) that belong to that kit
    const playableSubprograms =
        program?.subprograms?.filter(
            (sub) =>
                sub.screens?.some((s) => s.type === 'play') &&
                (!expansionKit || sub.kit === expansionKit)
        ) || []

    return (
        <>
            <div className="Main_Select">
                <div className="Select_Headers">
                    <MakeHeader
                        title={expansionKit ? `${EXPANSION_KITS[expansionKit]?.name || expansionKit}` : `${device} (v${deviceVersion})`}
                        titlePosition="left"
                        help_btnPosition="right"
                        isGoBack={true}
                        goBack={goBack}
                        showAccountSetting={true}
                        showHelp={true}
                        showBluetoothBtn={true}
                        showUsbBtn={Boolean(expansionKit)}
                        isExpansionKit={Boolean(expansionKit)}
                    />
                </div>

                <div className="TokiKits_Body">
                    {loading && (
                        <div
                            style={{
                                gridColumn: '1 / -1',
                                textAlign: 'center',
                                padding: '40px',
                            }}
                        />
                    )}

                    {!loading &&
                        playableSubprograms.map((sub) => (
                            <div
                                key={sub.id}
                                className="TokiKit_Card"
                                onClick={() => openSubprogram(sub.id)}
                                style={{
                                    opacity: props.isConnecting ? 0.5 : 1,
                                }}
                            >
                                <div
                                    className="TokiKit_CardImg"
                                    style={{ position: 'relative' }}
                                >
                                    <img
                                        src={getBackendImage(
                                            sub.image || 'projectDefault'
                                        )}
                                        alt={sub.title}
                                    />
                                </div>
                                <p className="TokiKit_CardName">{sub.title}</p>
                            </div>
                        ))}

                    {!loading && playableSubprograms.length === 0 && (
                        <div
                            style={{
                                gridColumn: '1 / -1',
                                textAlign: 'center',
                                padding: '40px',
                                color: '#888',
                                fontSize: '1.1rem',
                            }}
                        >
                            No play projects available yet.
                        </div>
                    )}
                </div>
            </div>

            <div className="loading-overlay">
                <ColorRing
                    visible={props.isConnecting}
                    height="80"
                    width="80"
                    ariaLabel="color-ring-loading"
                    colors={[
                        '#e15b64',
                        '#f47e60',
                        '#f8b26a',
                        '#abbd81',
                        '#849b87',
                    ]}
                />
            </div>
        </>
    )
}

const mapStateToProps = (state) => ({
    isConnecting: state.isConnecting,
})

export default connect(mapStateToProps)(Play)
